import React, { FC } from 'react';
import { ContactsView } from '../components';

export const InvalidContactsPage: FC = () => {
  return <ContactsView isInvalidContacts />;
};
